var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check"},[_c('p',[_vm._v("经过校验，类型："+_vm._s(_vm.checkInfo.check_result == 2 ? '商业地址' : '住宅地址'))]),_c('div',{staticClass:"check-btn"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.handleSure}},[_vm._v("确定")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }